import React, { useState } from "react";
import SEO from "components/SEO";
import tw from "twin.macro";
import styled from "styled-components";
import Layout from "../components/layouts/Layout";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton } from "components/misc/Buttons";
import MagazineLayout from "./MagazineLayout.js";
import GlobalStyles from "styles/GlobalStyles"; // ✅ import global styles

// Styled components
const Container = tw.div`max-w-screen-xl mx-auto py-20`;
const HeadingRow = tw.div`flex justify-center`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Posts = tw.div`mt-10 flex flex-wrap -mx-4`;
const PostContainer = styled.div`${tw`w-full md:w-1/2 lg:w-1/3 px-4 mb-8`}`;
const Post = tw.a`block bg-gray-100 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300`;
const Image = styled.div`
  ${props => tw`h-64 bg-cover bg-center`}
  background-image: url("${props => props.imageSrc}");
`;
const Info = tw.div`p-6`;
const Category = tw.div`text-primary-500 text-xs font-bold uppercase tracking-wider`;
const CreationDate = tw.div`text-gray-600 text-xs mt-1`;
const Title = tw.div`mt-2 font-bold text-xl text-gray-900`;
const Description = tw.div`mt-3 text-gray-700 text-sm leading-relaxed`;
const ButtonContainer = tw.div`flex justify-center mt-12`;
const LoadMoreButton = tw(PrimaryButton)``;

const getPlaceholderPost = () => ({
  imageSrc: "https://images.unsplash.com/photo-1418854982207-12f710b74003?auto=format&fit=crop&w=1024&q=80",
  category: "Travel Guide",
  date: "April 19, 2020",
  title: "Visit the beautiful Alps in Switzerland",
  description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  url: "https://reddit.com"
});

const SalsabeelIssues = ({
  headingText = "Salsabeel Issues",
  posts = [
    {
      imageSrc: "https://images.unsplash.com/photo-1499678329028-101435549a4e?auto=format&fit=crop&w=1024&q=80",
      category: "Travel Tips",
      date: "April 21, 2020",
      title: "Safely Travel in Foreign Countries",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      url: "https://timerse.com",
      featured: true
    },
    ...Array(10).fill(getPlaceholderPost())
  ]
}) => {
  const [visible, setVisible] = useState(6);
  const onLoadMoreClick = () => setVisible(v => v + 3);

  return (
    <>
      <SEO title="Salsabeel Magazine" description="Read Salsabeel — the official magazine of Jamia Mohammadia Arabia featuring Islamic scholarship, news, and student works." path="/magazine" />
      <GlobalStyles /> {/* ✅ Apply custom font globally */}
      <Layout>
        <Container>
          {/* Optional Heading */}
          {/* <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow> */}
          <MagazineLayout />

          {/* Sample: If showing posts */}
          {/* <Posts>
            {posts.slice(0, visible).map((post, index) => (
              <PostContainer key={index}>
                <Post href={post.url}>
                  <Image imageSrc={post.imageSrc} />
                  <Info>
                    <Category>{post.category}</Category>
                    <CreationDate>{post.date}</CreationDate>
                    <Title>{post.title}</Title>
                    {post.featured && <Description>{post.description}</Description>}
                  </Info>
                </Post>
              </PostContainer>
            ))}
          </Posts>
          {visible < posts.length && (
            <ButtonContainer>
              <LoadMoreButton onClick={onLoadMoreClick}>Load More</LoadMoreButton>
            </ButtonContainer>
          )} */}
        </Container>
      </Layout>
    </>
  );
};

export default SalsabeelIssues;
